import { useState, useEffect, useCallback } from 'react';

/**
 * Hook for fetching analytics dashboard data
 */
const useAnalyticsData = (startDate, endDate, region = null) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const token = localStorage.getItem('authToken');
      const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

      const params = new URLSearchParams();
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      if (region) params.append('region', region);

      const response = await fetch(
        `${API_URL}/api/analytics/dashboard?${params.toString()}`,
        { headers, credentials: 'include' }
      );

      if (!response.ok) {
        if (response.status === 403) {
          throw new Error('Access denied: Manager or admin privileges required');
        }
        throw new Error('Failed to fetch analytics data');
      }

      const result = await response.json();
      setData(result);
    } catch (err) {
      console.error('Analytics fetch error:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate, region]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};

export default useAnalyticsData;
